// Angular
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// Service
import { ViewsService } from '../../../../../../../../services/views.service';
import { CVfUtilsService } from '../../../../../../../services/cvf-utils.service';
// Model
import { FormControl, FormGroup } from '@angular/forms';
import { SCHEMA_TYPE } from '../../../../../../../../models/enums.model';
import { SmartTagTemplateForm } from '../../../model/smart-tag-template-form.model';
import { SmartTagFormControlModel } from '../../../model/smart-tag-form-control.model';
import { SmartTagSpaceModel } from '../../../model/smartTagSpace';
import { SmartTagTemplateModelClass } from '../../../model';

@Component({
	selector: 'cv-schema-render-smart-tag-space-template',
	templateUrl: './smart-tag-space-template.component.html',
})
export class SmartTagSpaceTemplateComponent extends SmartTagTemplateForm implements OnInit {

	@Input() smartTagModel: SmartTagSpaceModel = null;
	@Input() selectedSmartTagItem: any = null;
	@Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

	public orderSchema = '';

	get schemaShouldShowComplexForm(): boolean {
		let response = false;
		const schemasShouldShow = [
			SCHEMA_TYPE.CVDS_40.toString(),
			SCHEMA_TYPE.INSPECTIONLESS_1.toString()
		];

		response = schemasShouldShow.indexOf(this.orderSchema) > -1

		return response
	}

	constructor(
		private viewsService: ViewsService,
		protected cvfUtils: CVfUtilsService
	) {
		super(cvfUtils);
	}

	ngOnInit() {

		this.orderSchema = this.viewsService.order.schema;
		// Basic Form
		this.innerForm = new FormGroup({
			description: new FormControl(this.smartTagModel.description)
		});

		// Review if the selected Smart Tag Contain Form Controls
		this.prepareDynamicSmartTagFormControls(this.selectedSmartTagItem);

		switch (this.orderSchema) {
			case SCHEMA_TYPE.CVDS_40:
			case SCHEMA_TYPE.INSPECTIONLESS_1:
				this.innerForm.addControl('spaceCount', new FormControl(this.smartTagModel.spaceCount));

				this.formControl.forEach((formControl: SmartTagFormControlModel) => {
					this.addDynamicFormControl(formControl, this.smartTagModel);
				});

				break;
		}

		// Everytime the Form Change
		this.innerForm.valueChanges.subscribe(() => this.onValuesChange());
	}

	/**
	 * Emit values and status of this Form, for inner components and library too
	 * @private
	 */
	public onValuesChange(): void {
		const formValue = this.processOutputObject(this.smartTagModel, new SmartTagTemplateModelClass['TagSpace']);
		this.valueChange.next({ valid: this.innerForm.valid, value: formValue });
	}

}
